import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { FC } from 'react'

interface Props {
  loading: boolean
  desc?: string
}

const Loading: FC<Props> = ({ loading, desc }) =>
  loading && (
    <Box display="flex" alignItems="center" justifyContent="center">
      <CircularProgress />
      {desc && <Typography ml={2}>{desc}...</Typography>}
    </Box>
  )

export default Loading
